import { Component, OnInit, OnDestroy,Pipe,PipeTransform} from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Gallery,GalleryService } from './gallery.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { CopyWriteService} from './../services/copywrite.service';
import { EmbedVideoService } from 'ngx-embed-video';
import { MetaService } from 'ng2-meta';
declare var jQuery: any;


interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
  
}
@Component({
	//template: require('./gallery.component.html')
	templateUrl: './pg/gallery/gallery.component.html'
	
})

export class GalleryComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public gallery:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private metaService: MetaService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private copywriteservice:CopyWriteService,
	    private embedService: EmbedVideoService,
	    private _pageService: GalleryService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	  this.slimLoadingBarService.start();  
	  this._sub = this._route.params.subscribe(params => {
			
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   	let slug =params['slug'];			   	
			     this.category=slug;		   
			   
			   this._pageService.getGallerylist(slug,null).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                  this.pagedata.description=data.menu.description;                 
                  if(data.menu.meta_title)
                  {
	                   this._title.setTitle(data.menu.meta_title);
                  this.metaService.setTag('og:title',data.menu.meta_title);

                  }
                  else
                  this._title.setTitle(data.menu.link_showing_name);
                  
                  if(data.menu.meta_description)
                   this.metaService.setTag('description',data.menu.meta_description);
                  
                   this.metaService.setTag('keywords',data.menu.meta_keywords);
                                   
                  this.gallery=data.gallery;
                  this.slimLoadingBarService.complete();
                   let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);

                   setTimeout(()=>{    //<<<---    using ()=> syntax
         
                
			      let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);
			              
			      this.copywriteservice.copywritelogo(copywrite);
				  },1000);
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		});
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/gallery/gallery.component.ts